export default {
	ghsCashBalance: state => state.cashBalance['GHS'],
	usdCashBalance: state => state.cashBalance['USD'],
	cashBalanceOnCurrency: state => (currency = 'GHS') => {
		return state.cashBalance[currency]
	},
	cashBalance: state => state.cashBalance,
	accountShareHoldings: state => state.accountShareHoldings,
}
